import { render } from "./SegmentedTabs.vue?vue&type=template&id=09c9ecab&scoped=true"
import script from "./SegmentedTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedTabs.vue?vue&type=script&lang=js"

import "./SegmentedTabs.vue?vue&type=style&index=0&id=09c9ecab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c9ecab"]])

export default __exports__